<template>
    <div class="labels" @click.stop="toggle">
        <slot></slot>
        <div v-if="isOpen" @click.prevent.stop class="labels__box">
            <label-form v-if="isEditing" @created="addLabel" :label="label" @closed="cancel"></label-form>
            <template v-else>
                <ul class="labels__items">
                    <li class="labels__item" :class="{ 'labels__item--selected': hasLabel(label) }" :key="index" v-for="(label, index) in labels">
                        <a href="#" @click.prevent="toggleLabel(label)" class="label" :class="{[`label--${label.color}`]: true}">{{ label.name }}</a>
                        <a href="#" @click.prevent="editLabel(label)"><icon class="labels__edit" type="pencil-edit"></icon></a>
                    </li>
                </ul>
                <footer class="labels__footer">
                    <button @click.prevent.stop="newLabel" class="button button--small button--outline">Create new label</button>
                </footer>
            </template>
        </div>
    </div>
</template>
<script>
import Toggleable from '../../mixins/toggle'
import LabelForm from './LabelForm'
import Icon from './Icon'
import { mapState } from 'vuex'

export default {
    mixins: [Toggleable],

    props: {
        job: {
            type: Object,
            required: true
        }
    },

    data () {
        return {
            isEditing: false,
            label: null
        }
    },

    methods: {
        newLabel () {
            this.label = null
            this.isEditing = true
        },

        cancel () {
            this.isEditing = false
        },

        hasLabel (label) {
            return this.job.labels.find(item => item.id === label.id) !== undefined
        },

        toggleLabel (label) {
            this.hasLabel(label) ? this.removeLabel(label) : this.addLabel(label)
        },

        addLabel (label) {
            let data = {
                jobId: this.job.id,
                labelId: label.id
            }
            this.$store.dispatch('channel/addJobLabel', data)
        },

        removeLabel (label) {
            let data = {
                jobId: this.job.id,
                labelId: label.id
            }

            this.$store.dispatch('channel/removeJobLabel', data)
        },

        editLabel (label) {
            this.label = label
            this.isEditing = true
        }
    },

    computed: {
        ...mapState('channel', ['labels'])
    },

    components: {
        LabelForm,
        Icon
    }
}
</script>
